var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9097 8.09024L6.25476 9.76338M7.9097 8.09024L9.76901 9.74943M7.9097 8.09024L6.23593 6.25415M7.9097 8.09024L9.75063 6.23088M7.99995 14.5C9.81769 14.5 11.3689 13.8225 12.5957 12.5953M7.99995 14.5C6.1826 14.5 4.63152 13.8222 3.40439 12.5955M7.99995 14.5C9.85684 14.5 11.3756 13.8155 12.5957 12.5953M7.99995 14.5C6.14306 14.5 4.62455 13.8156 3.40439 12.5955M12.5957 12.5953C13.8225 11.3682 14.5 9.82941 14.5 8.0121M12.5957 12.5953C13.8159 11.3752 14.5 9.86895 14.5 8.0121M14.5 8.0121C14.5 6.19441 13.8228 4.63107 12.5956 3.40424M14.5 8.0121C14.5 6.15525 13.8158 4.62437 12.5956 3.40424M12.5956 3.40424C11.3685 2.1775 9.82961 1.5 8.01225 1.5M12.5956 3.40424C11.3755 2.18412 9.86914 1.5 8.01225 1.5M8.01225 1.5C6.19452 1.5 4.63114 2.17716 3.40429 3.40435M8.01225 1.5C6.15536 1.5 4.62444 2.18422 3.40429 3.40435M3.40429 3.40435C2.17752 4.63145 1.5 6.17029 1.5 7.9876M3.40429 3.40435C2.18414 4.62447 1.5 6.13075 1.5 7.9876M1.5 7.9876C1.5 9.80529 2.17718 11.3686 3.40439 12.5955M1.5 7.9876C1.5 9.84444 2.18424 11.3753 3.40439 12.5955",
    stroke: "#606266",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleClose);
export default __webpack_public_path__ + "static/media/circle-close.8a8fc8a6c6e699aba91b7d4c0eac5837.svg";
export { ForwardRef as ReactComponent };